const siteConfig = {
  brandName: "hushcider",
  wordmark: "HUSHCIDER",
  tagline: "Quiet focus. Vivid play.",
  description:
    "Performance-focused desk gear shaped by graphic design, considered materials, and the culture around play.",
  contact: {
    email: "hello@hushcider.cloud",
    hours: "Monday–Friday, 9am–5pm HKT",
    address: "Hong Kong",
  },
  commerce: {
    currency: "USD",
    locale: "en-HK",
    freeShippingThreshold: null,
    standardShipping: 9.99,
  },
  announcements: [
    "FLAT-RATE SHIPPING $9.99",
    "30-DAY RETURNS ON UNUSED GEAR",
  ],
};

export const formatPrice = (value) =>
  new Intl.NumberFormat(siteConfig.commerce.locale, {
    style: "currency",
    currency: siteConfig.commerce.currency,
  }).format(Number(value));

export default siteConfig;
